import { render, staticRenderFns } from "./EditExamShiftModal.vue?vue&type=template&id=56e861c2&scoped=true"
import script from "./EditExamShiftModal.vue?vue&type=script&lang=js"
export * from "./EditExamShiftModal.vue?vue&type=script&lang=js"
import style0 from "./EditExamShiftModal.vue?vue&type=style&index=0&id=56e861c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e861c2",
  null
  
)

export default component.exports